
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AuthenticationContext } from "vue-adal";
import axios from "axios";
import { default as parse } from "csv-parse/lib/sync";

interface BlankPresentationObj {
  id?: string;
  Version?: string;
  Culture?: string;
  BlankPresentationBLOB?: any;
  BlankPresentationSizeText?: string;
  ReleaseNotes?: string;
}

@Component({
  components: {},
})
export default class BlankPresentations extends Vue {
  private static async cvtBLOB2Base64_(b) {
    return new Promise((resolve, reject) => {
      if (!b) {
        resolve(null);
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        if (reader.result == null) {
          reject();
          return;
        }
        if (typeof reader.result !== "string") {
          reject();
          return;
        }
        const i = reader.result.indexOf(",");
        resolve(reader.result.substr(i + 1));
      };
      reader.readAsDataURL(b);
    });
  }

  public inputProps = {
    id: "autosuggest__input",
    placeholder: "Select Culture",
  };
  public suggestedCultures: any = [{ data: ["en-US"] }];
  public isBusy = false;
  public addingNewVersion = false;
  public isSaveButtonEnabled = true;
  public selected = [];
  public potxFile: any = null;
  public selectedVersion: BlankPresentationObj = {
    Version: "",
    Culture: "",
    id: undefined,
    BlankPresentationBLOB: null,
    BlankPresentationSizeText: "",
    ReleaseNotes: "",
  };
  public selectedUnchangedVersion: BlankPresentationObj = {};
  public filter: string = "";
  public fields = [
    {
      key: "Version",
      label: "Version",
      sortable: true,
    },
    {
      key: "Culture",
      label: "Culture",
      sortable: true,
    },
  ];
  public totalRows = 1;
  public versionsAvailable: any[] = [];
  public mounted() {
    this.loadVersions();
    document
      .querySelectorAll(".tableFixHead")
      .forEach((el) => el.addEventListener("scroll", this.tableFixHead));
  }

  @Watch("potxFile")
  public fileChanged(val: any, oldVal: any) {
    this.setSelectedBlankPresentationBLOB_(val);
  }

  // public async isSaveButtonEnabled() {
  //     let l: any = this.selectedUnchangedVersion;
  //     l.aaa = await BlankPresentations.cvtBLOB2Base64_(l.BlankPresentationBLOB);
  //     let r: any = this.selectedVersion;
  //     r.aaa = await BlankPresentations.cvtBLOB2Base64_(r.BlankPresentationBLOB);
  //     const result = JSON.stringify(l) != JSON.stringify(r);
  //     return result;
  // }

  public tableFixHead(e) {
    const el = e.target;
    const sT = el.scrollTop;
    el.querySelectorAll("thead th").forEach(
      (th) => (th.style.transform = `translateY(${sT}px)`)
    );
  }

  public onInputChange(text) {
    // event fired when the input changes
    console.log("Input Change", text);
    this.selectedVersion.Culture = text;
  }

  public onSelected(option) {
    if (option) {
      this.selectedVersion.Culture = option.item;
    }
  }
  public startCreateNewVersion() {
    this.selectedVersion.id = undefined;
    this.selectedVersion.Version = "";
    this.selectedVersion.ReleaseNotes = "";
    this.selectedVersion.Culture = "en-US";
    this.addingNewVersion = true;
    this.selectedVersion.BlankPresentationSizeText = "none";
    this.selectedVersion.BlankPresentationBLOB = null;
    Object.assign(this.selectedUnchangedVersion, this.selectedVersion);
    (this.$refs.versionTable as any).clearSelected();
    return true;
  }

  public loadVersions() {
    this.isBusy = true;
    this.addingNewVersion = false;
    this.cancel();
    axios
      .get(
        "/api/v4/Content/Data?filter-Category=SlideFox-Default-Presentation-Template&exclude=Value"
      )
      .then(
        (response) => {
          this.processVersionsAvailable_(response.data);
          this.isBusy = false;
        },
        (error) => {}
      );
  }

  public displayEditBox() {
    if (this.addingNewVersion) {
      return true;
    }
    if (this.selectedVersion.Version === "") {
      return false;
    }
    return true;
  }

  public async saveVersionChanges() {
    if (!this.isPresentationValid()) {
      return;
    }
    if (!this.selectedVersion.BlankPresentationBLOB) {
      this.makeToast(
        `Invalid template to upload (be sure it ends with .potx)`,
        "danger"
      );
      return;
    }

    // const reader = new FileReader();
    // reader.onload = e => {
    //     this.setSelectedBlankPresentationBLOB_(reader.result);
    // };
    // reader.readAsBinaryString(this.selectedVersion.BlankPresentationBLOB);

    let u: any = {
      Category: "SlideFox-Default-Presentation-Template",
      ContentType:
        "application/vnd.openxmlformats-officedocument.presentationml.template",
      Version: this.selectedVersion.Version,
      ReleaseNotes: this.selectedVersion.ReleaseNotes,
      Culture: this.selectedVersion.Culture,
      Value: await BlankPresentations.cvtBLOB2Base64_(
        this.selectedVersion.BlankPresentationBLOB
      ),
    };
    if (this.selectedVersion.id) {
      u.ID = this.selectedVersion.id;
    }
    this.isBusy = true;
    await axios.post("/api/v4/Content/Data", u).then(
      (response) => {
        this.isBusy = false;
        this.makeToast("Presentation template version saved!");
        this.loadVersions();
      },
      (error) => {
        this.isBusy = false;
        this.makeToast(
          `Presentation Template version could not be saved, please try again later. ${error.message}`,
          "danger"
        );
      }
    );
  }

  public isVersionValid(user?) {
    const validVer = /^(\d+\.)(\d+\.)(\d+\.)(\d+)$/;

    let u = this.selectedVersion;
    if (user) {
      u = user;
    }

    if (
      !u.Version ||
      u.Version.trim() === "" ||
      !u.Version.trim().match(validVer)
    ) {
      this.makeToast(
        "Enter a valid 4 part digits only Version number - X.X.X.X",
        "danger"
      );
      return false;
    }
    return true;
  }

  public isPresentationValid() {
    if (!this.isVersionValid()) {
      return false;
    }

    if (!this.selectedVersion.Culture || this.selectedVersion.Culture === "") {
      this.makeToast(`Culture cannot be empty`, "danger");
      return false;
    }

    return true;
  }

  public deleteVersion() {
    this.isBusy = true;
    const id = this.selectedVersion.id;
    axios.delete(`/api/v4/Content/Data/${id}`).then(
      (response) => {
        this.isBusy = false;
        this.makeToast("Presentation Template Version Deleted!");
        this.loadVersions();
      },
      (error) => {
        console.log(error);
        this.isBusy = false;
        this.makeToast(
          "Presentation Template Version Could not be deleted, please try again later.",
          "danger"
        );
      }
    );
  }

  public makeToast(msg, vrant = "success") {
    this.$bvToast.toast(`${msg}`, {
      title: "Operation Completed",
      autoHideDelay: 3000,
      variant: vrant,
      appendToast: false,
    });
  }

  // Take the already downloaded BlankPresentation and make it appear to the user as a download
  public fetchBlankPresentation() {
    const url = window.URL.createObjectURL(
      this.selectedVersion.BlankPresentationBLOB
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `ERS Presentation Template ${this.selectedVersion.Version}.potx`
    );
    document.body.appendChild(link);
    link.click();
  }

  public cancel() {
    this.selectedVersion.Version = "";
  }

  public rowSelected(items) {
    if (items.length > 0) {
      const u = items[0];
      this.selectedVersion.id = u.id;
      this.selectedVersion.Version = u.Version;
      this.selectedVersion.ReleaseNotes = u.ReleaseNotes;
      this.selectedVersion.Culture = u.Culture;
      this.setSelectedBlankPresentationBLOB_(null, "checking...");
      this.addingNewVersion = false;
      Object.assign(this.selectedUnchangedVersion, this.selectedVersion);
      axios({
        url: `/api/v4/Content/Data/${this.selectedVersion.id}?return=value`,
        method: "GET",
        responseType: "blob",
      }).then(
        (response) => {
          this.setSelectedBlankPresentationBLOB_(new Blob([response.data]));
          Object.assign(this.selectedUnchangedVersion, this.selectedVersion);
        },
        (error) => {
          console.log("TEM_ISSUE: ", error);
          this.selectedVersion.BlankPresentationSizeText = "no template found";
          this.makeToast("error retrieving template", "danger");
        }
      );
    }
    this.selected = items;
  }

  private setSelectedBlankPresentationBLOB_(b, msg?: string) {
    if (b != null && !(b instanceof Blob)) {
      throw new Error("oops"); // assert failure()
    }
    this.selectedVersion.BlankPresentationBLOB = b;
    if (!msg) {
      if (b == null) {
        msg = "none";
      } else {
        msg = `${(b.size / (1024 * 1024)).toFixed(3)} MB`;
      }
    }
    this.selectedVersion.BlankPresentationSizeText = msg;
  }

  private processVersionsAvailable_(d) {
    this.versionsAvailable.splice(0, this.versionsAvailable.length);
    const keys: any = Object.keys(d);
    const vals: any = Object.values(d);
    for (const k of keys) {
      const v = d[k];
      v.id = v["ID"];
      this.versionsAvailable.push(v);
    }
    this.totalRows = this.versionsAvailable.length;
  }
}
